<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">
                   <el-form-item label="金额:" prop="title_unit">
                       <el-input v-model="table.where.title_unit" placeholder="请输入金额" clearable>
                       </el-input>
                   </el-form-item>
                    <el-form-item label="标题:">
                        <el-input v-model="table.where.title" placeholder="请输入标题" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="商城数量:">
                        <el-input v-model="table.where.store_num" :min="0" placeholder="请输入商城数量" clearable />
                    </el-form-item>
                    <el-form-item label="小数点输入框:">
                        <el-input-number v-model="table.where.flot_price" controls-position="right" :min="0" :controls="false"
                            :precision="4" class="ele-fluid ele-text-left" placeholder="请输入小数点输入框" clearable />
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input-number v-model="table.where.phone" :controls="false" controls-position="right" :min="0"
                            placeholder="请输入手机号" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="文本框:" prop="area_text">
                        <el-input type="textarea" v-model="table.where.area_text" placeholder="请输入文本框" clearable />
                    </el-form-item>
                    <el-form-item label="单选下拉:">
                        <el-select v-model="table.where.timelist" filterable placeholder="请选择">
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单选:">
                        <el-radio-group v-model="table.where.hobbydata">
                            <el-radio :label="0">正常</el-radio>
                            <el-radio :label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="日期范围:">
                        <el-date-picker v-model="table.where.date_info" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="日期时间范围:" >
                        <el-date-picker v-model="table.where.timestamp" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="日期时间范围:" >
                        <el-date-picker v-model="table.where.datetimessss" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="时间范围:">
                        <el-time-picker is-range v-model="table.where.datetime" range-separator="至" start-placeholder="开始时间"
                            end-placeholder="结束时间" placeholder="选择时间范围" value-format="hh:mm:ss">
                        </el-time-picker>
                    </el-form-item>
                    
                    
                    
                    <el-form-item label="会员id:">
                        <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员id:" >
                        <el-select v-model="table.where.admin_id" filterable placeholder="请选择">
                            <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="关联其他id:" >
                        <el-select v-model="table.where.store_goods_category_id" filterable placeholder="请选择">
                            <el-option v-for="item in store_goods_catrgory_list" :key="item.id" :label="item.cate_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员id多选:" >
                        <el-select v-model="table.where.user_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员id多选:" >
                        <el-select v-model="table.where.admin_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="关联其他id多选:">
                        <el-select v-model="table.where.store_goods_category_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in store_goods_catrgory_list" :key="item.id" :label="item.cate_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单选下拉:" prop="timelist">
                        <el-select v-model="table.where.timelist" filterable placeholder="请选择">
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="多选下拉:" prop="timeslist">
                        <el-select v-model="table.where.timeslist" multiple filterable placeholder="请选择">
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="多选:">
                        <el-checkbox-group v-model="table.where.hobbysdata">
                            <el-checkbox label="0">隐藏</el-checkbox>
                            <el-checkbox label="1">正常</el-checkbox>
                            <el-checkbox label="2">推荐</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="小数点输入框:" prop="decimal_price">
                        <el-input-number v-model="table.where.decimal_price" controls-position="right" :min="0" :controls="false"
                            :precision="4" class="ele-fluid ele-text-left" placeholder="请输入小数点输入框" clearable />
                    </el-form-item>
                    <el-form-item label="地址选择器:">
                        <el-cascader v-model="table.where.address_city" :options="cityData.cityDataLabel" clearable
                            popper-class="ele-pop-wrap-higher" @change="cityInfo" :props="{ checkStrictly: true }" />
                    </el-form-item>
                    
                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:level:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small" v-if="permission.includes('sys:level:add')">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:level:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:level:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip />
                        
                    
                    <el-table-column prop="title_unit" label="金额" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="phone" label="手机号" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="title" label="标题" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="store_num" label="商城数量"  show-overflow-tooltip min-width="250" />
                    <el-table-column prop="siteswitch" label="开关"  :resizable="false" min-width="120">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.siteswitch" @change="editStatus(row)" :active-value="1"
                                :inactive-value="2" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="flot_price" label="小数点输入框" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="datetime" label="时间选择器"  show-overflow-tooltip min-width="250" />
                    <el-table-column prop="date_info" label="时间选择器" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="timestamp" label="时间日期选择"  show-overflow-tooltip min-width="250" />
                    
                    <el-table-column prop="user_id" label="会员id" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_ids" label="会员ids" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_ids_info" :key="index">{{item.nick_name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="admin_id" label="管理员id" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.admin_id_info" :key="index">{{item.realname}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="admin_ids" label="管理员ids" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.admin_ids_info" :key="index">{{item.realname}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="store_goods_category_id" label="关联其他id" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.store_goods_category_id_info" :key="index">{{item.cate_name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="store_goods_category_ids" label="关联其他ids" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.store_goods_category_ids_info" :key="index">{{item.cate_name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="smallimage" label="图片" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-image
                               style="width: 50px; height: 50px"
                               :src="row.smallimage" 
                               :preview-src-list="[row.smallimage]">
                             </el-image>
                        </template>
                    </el-table-column>
                     
                    <el-table-column prop="smallimages" label="多图片" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-image
                                v-for="(item,index) in row.smallimages"
                                :key="index"
                               style="width: 50px; height: 50px"
                               :src="item" 
                               :preview-src-list="row.smallimages">
                             </el-image>
                        </template>
                    </el-table-column>
                     
                    <el-table-column prop="attachfile" label="文件" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <a :href="row.attachfile" target="_blank"><el-tag>文件</el-tag></a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attachfiles" label="多文件" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <a v-for="(item,index) in row.attachfiles" :key="index" :href="item" target="_blank"><el-tag>文件{{index+1}}</el-tag></a>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="miniavatar" label="头像单个" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-image
                               style="width: 50px; height: 50px"
                               :src="row.miniavatar" 
                               :preview-src-list="[row.miniavatar]">
                             </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="miniavatars" label="头像多个" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-image
                                v-for="(item,index) in row.smallimages"
                                :key="index"
                               style="width: 50px; height: 50px"
                               :src="item" 
                               :preview-src-list="row.smallimages">
                             </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="timelist" label="单选下拉" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                               <el-tag v-if="row.timelist == 0" >隐藏</el-tag>
                               <el-tag v-if="row.timelist == 1" >正常</el-tag>
                               <el-tag v-if="row.timelist == 2" >推荐</el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="timeslist" label="多选下拉" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <block v-for="(item,index) in row.timeslist" :key="index">
                                <el-tag v-if="item == 0" >隐藏</el-tag>
                                <el-tag v-if="item == 1" >正常</el-tag>
                                <el-tag v-if="item == 2" >推荐</el-tag>
                            </block>
                               
                        </template>
                    </el-table-column>
                    <el-table-column prop="hobbydata" label="单选" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                               <el-tag v-if="row.hobbydata == 0" >隐藏</el-tag>
                               <el-tag v-if="row.hobbydata == 1" >正常</el-tag>
                               <el-tag v-if="row.hobbydata == 2" >推荐</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="hobbysdata" label="多选" show-overflow-tooltip min-width="250"  >
                        <template slot-scope="{row}">
                            <block v-for="(item,index) in row.hobbysdata" :key="index">
                                <el-tag v-if="item == 0" >隐藏</el-tag>
                                <el-tag v-if="item == 1" >正常</el-tag>
                                <el-tag v-if="item == 2" >推荐</el-tag>
                            </block>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="daterange" label="日期范围" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                               <el-tag v-for="(item,index) in row.daterange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="datetimierange" label="日期时间范围" show-overflow-tooltip min-width="300" >
                        <template slot-scope="{row}">
                               <el-tag v-for="(item,index) in row.datetimierange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="timerange" label="时间范围" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                               <el-tag v-for="(item,index) in row.timerange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="decimal_price" label="小数点输入框" show-overflow-tooltip min-width="250" />
                    <el-table-column prop="address_city" label="地址选择器" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                               <el-tag v-for="(item,index) in row.address_city" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="city_map" label="地图选择器" show-overflow-tooltip min-width="250" />
                    
                    
                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip />
                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:level:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此职级吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:level:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改职级':'修改职级'" :visible.sync="showEdit" width="800px" :destroy-on-close="true"
            :lock-scroll="false" @close="closeDialog">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="金额:" prop="title_unit">
                    <el-input v-model="editForm.title_unit" placeholder="请输入金额" clearable>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="标题:" prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入标题" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="商城数量:" prop="store_num">
                    <el-input v-model="editForm.store_num" :min="0" placeholder="请输入商城数量" clearable />
                </el-form-item>
                <el-form-item label="手机号:" prop="phone">
                    <el-input-number v-model="editForm.phone" :controls="false" controls-position="right" :min="0"
                        placeholder="请输入手机号" class="ele-fluid ele-text-left" clearable />
                </el-form-item>
                <el-form-item label="开关:" prop="siteswitch">
                    <el-switch v-model="editForm.siteswitch" active-text="正常" inactive-text="隐藏" :active-value="1" :inactive-value="0" />
                </el-form-item>

                <el-form-item label="小数点输入框:" prop="flot_price">
                    <el-input-number v-model="editForm.flot_price" controls-position="right" :min="0" :controls="false"
                        :precision="4" class="ele-fluid ele-text-left" placeholder="请输入小数点输入框" clearable />
                </el-form-item>

                <el-form-item label="文本框:" prop="area_text">
                    <el-input type="textarea" v-model="editForm.area_text" placeholder="请输入文本框" clearable />
                </el-form-item>
                <el-form-item label="时间选择器:" prop="datetime">
                    <el-time-select v-model="editForm.datetime"  placeholder="选择时间">
                    </el-time-select>
                </el-form-item>
                <el-form-item label="日期选择:" prop="date_info">
                    <el-date-picker v-model="editForm.date_info" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间日期选择:" prop="timestamp">
                    <el-date-picker v-model="editForm.timestamp" type="datetime" placeholder="选择时间" size="small" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间日期其他:" prop="datetimessss">
                    <el-date-picker v-model="editForm.datetimessss" type="datetime" placeholder="选择时间" size="small" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>
                
                <el-form-item label="会员id:" prop="user_id">
                    <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="会员id多选:" prop="user_ids">
                    <el-select v-model="editForm.user_ids" multiple placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管理员id:" prop="admin_id">
                    <el-select v-model="editForm.admin_id" filterable placeholder="请选择">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管理员id多选:" prop="admin_ids">
                    <el-select v-model="editForm.admin_ids" multiple placeholder="请选择">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联其他id:" prop="time">
                    <el-select v-model="editForm.store_goods_category_id" filterable placeholder="请选择">
                        <el-option v-for="item in store_goods_catrgory_list" :key="item.id" :label="item.cate_name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联其他id多选:" prop="time">
                    <el-select v-model="editForm.store_goods_category_ids" multiple placeholder="请选择">
                        <el-option v-for="item in store_goods_catrgory_list" :key="item.id" :label="item.cate_name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序号:" prop="sort">
                    <el-input-number v-model="editForm.sort" :controls="false" controls-position="right" :min="0"
                        placeholder="请输入排序号" class="ele-fluid ele-text-left" clearable />
                </el-form-item>
                
                <el-form-item label="图片:" prop="smallimage">
                    <ele-uploadimage :limit="1" v-model="editForm.smallimage"></ele-uploadimage>
                </el-form-item>
                
                <el-form-item label="图片:" prop="smallimages">
                    <ele-uploadimage :limit="9" v-model="editForm.smallimages"></ele-uploadimage>
                </el-form-item>
                <el-form-item label="文件:" prop="attachfile">
                    <ele-upload-resource-other :limit="1" v-model="editForm.attachfile"></ele-upload-resource-other>
                </el-form-item>
                <el-form-item label="文件:" prop="attachfiles">
                    <ele-upload-resource-other :limit="9" v-model="editForm.attachfiles"></ele-upload-resource-other>
                </el-form-item>
                <el-form-item label="头像单个:" prop="miniavatar">
                    <ele-uploadimage :limit="1" v-model="editForm.miniavatar"></ele-uploadimage>
                </el-form-item>
                <el-form-item label="头像多个:" prop="miniavatars">
                    <ele-uploadimage :limit="9" v-model="editForm.miniavatars"></ele-uploadimage>
                </el-form-item>
                <el-form-item label="富文本:" prop="maincontent">
                    <tinymce-editor v-model="editForm.maincontent" :init="initEditor" />
                </el-form-item>
                <el-form-item label="单选下拉:" prop="timelist">
                    <el-select v-model="editForm.timelist" filterable placeholder="请选择">
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="多选下拉:" prop="timeslist">
                    <el-select v-model="editForm.timeslist"  multiple filterable placeholder="请选择">
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单选:">
                    <el-radio-group v-model="editForm.hobbydata">
                        <el-radio label="0">隐藏</el-radio>
                        <el-radio label="1">正常</el-radio>
                        <el-radio label="2">推荐</el-radio>
                        
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item label="多选:">
                    <el-checkbox-group v-model="editForm.hobbysdata">
                        <el-checkbox label="0">隐藏</el-checkbox>
                        <el-checkbox label="1">正常</el-checkbox>
                        <el-checkbox label="2">推荐</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="小数点输入框:" prop="decimal_price">
                    <el-input-number v-model="editForm.decimal_price" controls-position="right" :min="0" :controls="false"
                        :precision="4" class="ele-fluid ele-text-left" placeholder="请输入小数点输入框" clearable />
                </el-form-item>
                <el-form-item label="日期范围:" prop="daterange">
                    <el-date-picker v-model="editForm.daterange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="日期时间范围:" prop="datetimierange">
                    <el-date-picker v-model="editForm.datetimierange" type="datetimerange" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间范围:" prop="timerange">
                    <el-time-picker is-range v-model="editForm.timerange" range-separator="至" start-placeholder="开始时间"
                        end-placeholder="结束时间" placeholder="选择时间范围" value-format="hh:mm:ss">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="地址选择器:" prop="address_city">
                    <el-cascader v-model="editForm.address_region" :options="cityData.cityDataLabel" clearable
                        popper-class="ele-pop-wrap-higher" @change="cityInfo" />
                </el-form-item>
                <el-form-item label="地图选择器:" prop="city_map">
                    <ele-upload-map v-model="editForm.city_map"></ele-upload-map>  
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import TinymceEditor from '@/components/TinymceEditor'
    import EleUploadimage from '@/components/EleUploadimage'
    import EleUploadResourceOther from '@/components/EleUploadResourceOther'
    import EleUploadMap from '@/components/EleUploadMap'
    import cityData from '@/utils/cityData'
    import {
        mapGetters
    } from "vuex";
    export default {
        components: {
            TinymceEditor,
            EleUploadimage,
            EleUploadResourceOther,
            EleUploadMap,
        },
        name: "SysLevel",
        data() {
            return {
                cityData: cityData, // 省市区数据
                table: {
                    url: '/ceshi/ceshi/index',
                    where: {
                        hobbysdata:[]
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    status: 1,
                    hobbysdata: []
                }, // 表单数据
                editRules: { // 表单验证规则
                    title_unit: [
                      {required: true, message: '请输入广告标题', trigger: 'blur'}
                    ],
                    phone: [
                      {required: true, message: '请选择所属广告位', trigger: 'blur'},
                        {pattern:/^1(3|4|5|6|7|8|9)\d{9}$/,message: '手机号格式不对',trigger: 'blur'}
                    ],
                    title: [
                      {required: true, message: '请选择广告类型', trigger: 'blur'}
                    ],
                    store_num: [
                      {required: true, message: '请输入广告描述', trigger: 'blur'}
                    ],
                    status: [
                      {required: true, message: '请输入广告宽度', trigger: 'blur'}
                    ],
                    siteswitch: [
                      {required: true, message: '请输入广告高速', trigger: 'blur'}
                    ],
                    flot_price: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    area_text: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    datetime: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    date_info: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    timestamp: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    datetimessss: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    user_id: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    user_ids: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    admin_id: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    admin_ids: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    store_goods_category_id: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    store_goods_category_ids: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    sort: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    smallimage: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    smallimages: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    attachfile: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    attachfiles: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    miniavatar: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    miniavatars: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    maincontent: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    timelist: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    timeslist: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    hobbydata: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    hobbysdata: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    daterange: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    datetimierange: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    timerange: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    decimal_price: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    city_map: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                    address_city: [
                      {required: true, message: '请输入排序', trigger: 'blur'}
                    ],
                },
                search_show: false,//搜索栏显示
                admin_list:[],
                user_list:[],
                store_goods_catrgory_list:[]
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            }
        },
        mounted() {
            this.adminAllList();
            this.userAllList();
            this.StoreGoodsCategoryAllList();
        },
        methods: {
            /* 关闭*/
            closeDialog(){
              this.showEdit = false;
            },
            /* 获取全部管理员 */
            adminAllList(){
                this.$http.post('/admin/admin/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.admin_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 获取全部会员 */
            userAllList(){
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            StoreGoodsCategoryAllList(){
                this.$http.post('/store/StoreGoodsCategory/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_catrgory_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 显示编辑 */
            edit(row) {
                this.editForm = Object.assign({}, row);
                this.showEdit = true;
            },
            /* 保存编辑 */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/ceshi/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /* 删除 */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的职级吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/ceshi/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/ceshi/ceshi/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },
            /* 更改状态 */
            editStatus(row) {
                const loading = this.$loading({
                    lock: true
                });
                let params = Object.assign({}, row);
                this.$http.post('/ceshi/ceshi/status', params).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row.status = !row.status ? 2 : 1;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            cityInfo(e){
                console.log(e)
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>


















